import Map from '@va/deprecated/components/maps/LeafletMap';
import { LoadingLogo, NoDataMessage } from '@va/ui/design-system';

import { PrivacyLevelsEnum } from '@va/standalone/shared/types';
import { useMemo, useState } from 'react';
import './leaflet-map.scss';

export type LeafletMapRawPoint = {
  sessionKey: string;
  lat: number;
  lng: number;
  privacyLevel: PrivacyLevelsEnum;
};

type LeafletMapPanelProps = {
  inProgress: boolean;
  circleRadius?: number;
  shouldHighlightPoint?: (point: LeafletMapRawPoint) => boolean;
  items: LeafletMapRawPoint[];
  center?: {
    latitude: number;
    longitude: number;
  };
  isPointSelected?: (point: LeafletMapRawPoint) => boolean;
  zoom?: number;
};

const LeafletMapPanel = ({
  inProgress,
  items,
  center,
  circleRadius = 2500,
  zoom,
  isPointSelected,
}: LeafletMapPanelProps) => {
  const [isMapCreated, setIsMapCreated] = useState(false);
  const hasInformation = () => {
    return !(items.length === 0 || (items.length === 1 && isNaN(items[0].lat)));
  };

  const points = useMemo(
    () =>
      items.map((item) => {
        const isSelected = isPointSelected?.(item);

        const point = {
          sessionKey: item.sessionKey,
          isPrivate: PrivacyLevelsEnum.completePrivacy === item.privacyLevel,
          lat: item.lat,
          lng: item.lng,
          isHighlighted: isSelected,
        };

        return point;
      }),
    [isPointSelected, items],
  );

  return (
    <div className='traffic-box-container'>
      <div className='traffic-body leaflet-map-container relative'>
        {!hasInformation() && !inProgress && (
          <div className='w-full h-full flex items-center'>
            <NoDataMessage type='panel' />
          </div>
        )}
        {!inProgress && hasInformation() && (
          <div className='w-full h-full'>
            <Map
              points={points}
              center={center}
              zoom={zoom}
              circleRadius={circleRadius}
              whenCreated={() => setIsMapCreated(true)}
            />
          </div>
        )}
        {(inProgress || !isMapCreated) && (
          <div className='bg-white w-full h-full absolute z-10'>
            <LoadingLogo />
          </div>
        )}{' '}
      </div>
    </div>
  );
};

export default LeafletMapPanel;
